// extracted by mini-css-extract-plugin
export default {"arrows":"Arrows_arrows__cQjwA","arrow":"Arrows_arrow__S2tLm"};